import React from "react";
import { useLocation } from "react-router-dom";
import ModuleSubtopic from "../../../ModuleSubtopic";

const ParityGeneratorChecker = () => {
  const location = useLocation();
  const { subtopics, subjectPath } = location.state || { subtopics: [], subjectPath: '' };

  return (
  <ModuleSubtopic
      subtopics={subtopics}
      subjectPath={subjectPath}
      title="Parity generator and checker"
    videos={[
      "https://www.youtube.com/embed/c8qAti1zBVQ",
      "https://www.youtube.com/embed/RfTGvpY2Z5Y"
    ]}
    takeaways={[
      { text: "Mainly direct question comes from this topic" }
    ]}
    questions={[
      "Consider a data transmission system used to transmit 4-bit data. The system uses odd parity to detect the error in transmission. Design a system that generates the parity at the transmitter side and checks the parity at receiver side. Also Write the Verilog Code for the above design",
      "Construct the truth table of 1 bit parity generator for 3 bit-input using odd parity and implement its Boolean function using 8:1 Multiplexer",
      "Implement a combinational system which is fully design by using MUX and have the facility to generate and check the odd parity for 3 bit binary input"
    ]}
    exampleVideos={[]}
  />
);
}

export default ParityGeneratorChecker;
